import _queryString from 'query-string';

export type StringifiableRecord = _queryString.StringifiableRecord;

export const queryString = _queryString;
